import React, { ComponentProps } from "react";
import { Icon } from "@clarkinc/zest-design-system/ui";
import { cls } from "@wss/cls";
const Error = ({
  children,
  ...rest
}: ComponentProps<"div">) => <div aria-live="polite" id="sh-quantity-error" className={cls("absolute top-14 flex gap-1", "py-2.5 px-3-2/3 text-sm text-red-700 border border-solid border-red-600 rounded bg-red-100 z-10")} {...rest} data-sentry-component="Error" data-sentry-source-file="index.tsx">
    <Icon name="ri-alert-fill" className="relative top-[1px] fill-red-700 w-4 h-4" data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
    {children}
  </div>;
export default Error;